<template>
  <TheNavbar />

  <div class="mt-5 mb-5">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <p>
          The widget below is provided by Canny.io and helps us to keep track of all your ideas on how to improve SIGNUM further ❤️<br>
          Let's Go 💪🏼
        </p>
      </div>
    </div>

    <CannyWidget :key="theme" :theme="theme" />
  </div>
</template>

<script>
  import TheNavbar from '@/components/TheNavbar'
  import CannyWidget from '@/components/CannyWidget'

export default {
  components: {
    TheNavbar,
    CannyWidget
  },
  computed: {
    theme () {
      return this.$store.getters.getTheme
    },
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }
}
</script>
